module.exports = __webpack_public_path__ + "static/vision_image-9865227193997f9a470f630a322713f8.jpg";